import { DownloadItemType } from "../../types";
import { postFileRequestWrapper } from "../../utilities";

export type createEnvironmentResponse = DownloadItemType;

type createEnvironmentBody = {
  version_number: string;
  display_name: string | null;
  store_id: string;
  app_id: string;
};

export function createEnvironment(
  body: createEnvironmentBody,
  file: File
): Promise<createEnvironmentResponse> {
  return postFileRequestWrapper<
    createEnvironmentBody,
    createEnvironmentResponse
  >({
    url: `${ENV_SETTINGS.API_URL}/environments`,
    body,
    file,
  });
}
